import styled from "styled-components"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { Link as ScrollLink } from "react-scroll"

export const Button = styled.button`
  font-size: ${props => props.theme.fontSizes.bodyReg};
  color: ${props => props.theme.colors.buttonTextColor};
  background: ${props => props.theme.colors.brandColor};
  border-radius: 100rem;
  padding: 0.6rem 2.3rem;
  line-height: 1.5;
  border: none;
  display: flex;
  font-weight: 700;
  margin-top: 1.5rem;
  text-decoration: none;
  cursor: pointer;
`

export const ButtonLink = styled(AnchorLink)`
  font-size: ${props => props.theme.fontSizes.bodyReg};
  color: ${props => props.theme.colors.buttonTextColor};
  background: ${props => props.theme.colors.brandColor};
  border-radius: 100rem;
  padding: 0.6rem 2.3rem;
  line-height: 1.5;
  border: none;
  display: inline-block;
  font-weight: 700;
  margin-top: 1.5rem;
  text-decoration: none;
  cursor: pointer;
`

export const ScrollButtonLink = styled(ScrollLink)`
  font-size: ${props => props.theme.fontSizes.bodyReg};
  color: ${props => props.theme.colors.buttonTextColor};
  background: ${props => props.theme.colors.brandColor};
  border-radius: 100rem;
  padding: 0.6rem 2.3rem;
  line-height: 1.5;
  border: none;
  display: inline-block;
  font-weight: 700;
  margin-top: 1.5rem;
  text-decoration: none;
  cursor: pointer;
`
